import _ from 'underscore';
import Localizer from 'localizer';
import ModalPopupView from 'views/main/Modal/ModalPopupView';
import UserExperienceSetupView from 'views/user/UserExperienceSetupView';
import UserExperienceModalFooter from 'templates/user/UserExperienceModalFooter.html';

var Events = {
    CREATE_DASHBOARD_CLICK: 'CREATE_DASHBOARD_CLICK',
    ON_EXPERIENCES_SAVED: UserExperienceSetupView.Events.ON_EXPERIENCES_SAVED,
    ON_SWITCHES_CHANGE: UserExperienceSetupView.Events.ON_SWITCHES_CHANGE
};

var UserExperienceModalPopupView = ModalPopupView.extend({
    showFooter: true,
    showCloseButton: false,
    customClasses: 'select-your-experience',
    options: {
        backdrop: 'static',
        keyboard: false
    },

    events: {
        'click #select-experience-save': 'onCreateDashboardClick'
    },

    initialize: function(args) {
        this.marinePref = args.marinePref;

        // create new modal content view
        this.view = new UserExperienceSetupView({
            saveEvent: Events.CREATE_DASHBOARD_CLICK,
            marinePref: this.marinePref
        });

        // set modal title
        this.modalTitle = Localizer.localize('userexperience.dialog.title');

        // set modal footer template to use the custom "Create Dashboard" button
        this.footerTemplate = _.template(UserExperienceModalFooter);

        // Event listeners
        this.listenTo(this.view, Events.ON_EXPERIENCES_SAVED, this.onExperiencesSaved);
        this.listenTo(this.view, Events.ON_SWITCHES_CHANGE, this.onSwitchesChange);
        this.listenTo(this.view, 'ON_CLOSE', this.close);
    },

    onCreateDashboardClick: function(e) {
        e.preventDefault();

        this.view.trigger(Events.CREATE_DASHBOARD_CLICK, e.currentTarget);
    },

    /**
     * Called when the modal view triggers an "ON_EXPERIENCES_SAVED" event
     * Triggers the same event on this view, to be handled further by the MainRouter
     */
    onExperiencesSaved: function() {
        this.trigger(Events.ON_EXPERIENCES_SAVED);
    },

    /**
     * Disables the save button when there are no switches active. Enables it otherwise
     * @param switches - int - number of switches that are currently active
     */
    onSwitchesChange: function(switches) {
        var $saveButton = this.$('#select-experience-save');

        if (switches === 0) {
            $saveButton.attr('disabled', 'disabled');
        } else {
            $saveButton.removeAttr('disabled');
        }
    }
});

UserExperienceModalPopupView.Events = Events;

export default UserExperienceModalPopupView;
